import { useClientStorage } from './useClientStorage'

export const useSessionStorage = (key, initialValue = '') =>
  useClientStorage(key, initialValue, 'session')
